module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.7776/js/img/CRM.svg"